/* eslint-disable no-prototype-builtins */
import Vue from 'vue';
import VueRouter from 'vue-router';
import SocialAnalytics from './views/analytics/SocialAnalytics.vue';

import CampaignEditorHome from './views/brand-builder/CampaignEditorHome.vue';
import bbCampaigns from './views/brand-builder/brand-builder-nested-routes/BbCampaign.vue';
import bbColors from './views/brand-builder/brand-builder-nested-routes/BbColors.vue';
import bbDesign from './views/brand-builder/brand-builder-nested-routes/BbDesign.vue';
import bbImages from './views/brand-builder/brand-builder-nested-routes/BbImages.vue';
import bbUploadImages from './views/brand-builder/brand-builder-nested-routes/BbUploadImages.vue';
import bbLegal from './views/brand-builder/brand-builder-nested-routes/BbLegal.vue';
import bbPartners from './views/brand-builder/brand-builder-nested-routes/BbPartners.vue';
import bbText from './views/brand-builder/brand-builder-nested-routes/BbText.vue';
import bbBranding from './views/brand-builder/brand-builder-nested-routes/BbBranding.vue';
import bbMedia from './views/brand-builder/brand-builder-nested-routes/BbMediaType.vue';
import bbSelectContent from './views/brand-builder/brand-builder-nested-routes/BbSelectContent.vue';
import bbPricing from './views/brand-builder/brand-builder-nested-routes/BbPricing.vue';
import bbExport from './views/brand-builder/brand-builder-nested-routes/BbExport.vue';
import bbVideoExport from './views/brand-builder/brand-builder-nested-routes/BbVideoExport.vue';
import bbPptExport from './views/brand-builder/brand-builder-nested-routes/BbPptExport.vue';
import bbPreview from './views/brand-builder/brand-builder-nested-routes/BbPreview.vue';

import CampaignEditorWorkspace from './views/brand-builder/CampaignEditorWorkspace.vue';
import MarketingCalendarHome from './views/marketing-calendar/MarketingCalendarHome.vue';
import MarketingCalendarSuggested from './views/marketing-calendar/MarketingCalendarSuggested.vue';
import MarketingCalendarScheduled from './views/marketing-calendar/MarketingCalendarScheduled.vue';

// video reviews
import VideoReviewActivation from './views/video-reviews/VideoReviewActivation.vue';

// client connect v2.0
import ClientConnectV2Home from './views/client-connect-v2/ClientConnectHome.vue';
import ClientConnectV2Alerts from './views/client-connect-v2/ClientConnectAlerts.vue';
import ClientConnectV2Contacts from './views/client-connect-v2/contacts/ClientConnectContacts.vue';
import ContactsTable from './views/client-connect-v2/contacts/ContactsTable.vue';

// drip campaigns
import DripCampaignsHome from './views/client-connect-v2/drip-campaigns/DripCampaignsHome.vue';
import DripCampaignsOverview from './views/client-connect-v2/drip-campaigns/DripCampaignsOverview';
import DripCampaignItem from './views/client-connect-v2/drip-campaigns/DripCampaignItem';

import MarketingResourcesHome from './views/marketing-resources/MarketingResourcesHome.vue';
import MarketingViewAll from './views/marketing-resources/MarketingViewAll.vue';
import MarketingResourcesDetails from './views/marketing-resources/MarketingResourcesDetails.vue';

import PreferenceCenterHome from './views/preference-center/PreferenceCenterHome.vue';
import PreferenceCenterCompany from './views/preference-center/PreferenceCenterCompany.vue';
import PreferenceCenterDisclaimers from './views/preference-center/PreferenceCenterDisclaimers.vue';
import PreferenceCenterUser from './views/preference-center/PreferenceCenterUser.vue';
import PreferenceCenterPermissions from './views/preference-center/PreferenceCenterPermissions.vue';
import PreferenceCenterPartners from './views/preference-center/PreferenceCenterPartners.vue';
import PreferenceCenterAlerts from './views/preference-center/PreferenceCenterAlerts.vue';
import PreferenceCenterFindAMortgageBroker from './views/preference-center/PreferenceCenterFindAMortgageBroker.vue';

import Home from './views/Home.vue';
import oidcManager from './services/auth/oidc-manager';
import store from './store/index';
import profileApiClient from './services/profile/profile-service';
import cookieClient from './services/auth/cookie-verification-service';
import { ERROR_DETAILS } from './constants/error-details';
import isBrowserStorageSupported from '@/util/isBrowserStorageSupported';
import PageNotFound from './views/PageNotFound.vue';

Vue.use(VueRouter);

const router = new VueRouter({
	routes: [
		{
			path: '/',
			name: 'Dashboard',
			component: Home,
			meta: {
				showSubNav: false,
				menuData: { iconWeight: 'fal', icon: 'tachometer-fast' },
				analytics: {
					pageviewTemplate(route) {
						return {
							title: 'Brand360 Home',
							page: `${route.path}Brand360-Home`,
							location: window.location.href,
						};
					},
				},
			},
		},
		{
			path: '/boost',
			name: 'Boost',
			beforeEnter() {
				window.open('https://www.clientconvert.com', '_blank');
			},
			meta: {
				menuData: {
					iconWeight: 'fal',
					icon: 'infinity',
				},
			},
		},
		{
			path: '/video-review-activation',
			name: 'Video Reviews',
			component: VideoReviewActivation,
			meta: {
				hasSocialVAccount: false,
				menuData: {
					iconWeight: 'fal',
					icon: 'video',
				},
			},
		},
		{
			path: '/adfs',
			name: 'Video Reviews',
			beforeEnter() {
				store.dispatch('setVideoReviewSpinner', true);
				store.dispatch('getADFSLink');
			},
			meta: {
				hasSocialVAccount: true,
				loadingSpinner: true,
				menuData: {
					iconWeight: 'fal',
					icon: 'video',
				},
			},
		},
		{
			path: '/client-connect-v2',
			name: 'Client Connect',
			component: ClientConnectV2Home,
			beforeEnter(to, from, next) {
				if (store.state.profile.isPilotUser) {
					window.location = 'https://mkt.uwm.com/leadpipeline';
				} else {
					next();
				}
			},
			redirect: { name: 'CCV2-Alerts' },
			meta: {
				showSubNav: true,
				menuData: { iconWeight: 'fal', icon: 'users-medical' },
			},
			children: [
				{
					name: 'CCV2-Contacts',
					path: 'contacts',
					component: ClientConnectV2Contacts,
					children: [
						{
							name: 'Active',
							path: 'active',
							component: ContactsTable,
							props: { activeContacts: true },
						},
						{
							name: 'Inactive',
							path: 'inactive',
							component: ContactsTable,
							props: { activeContacts: false },
						},
					],
				},
				{
					name: 'CCV2-Alerts',
					path: 'alerts',
					component: ClientConnectV2Alerts,
				},
				{
					path: 'alerts/:type',
					component: ClientConnectV2Alerts,
				},
				{
					name: 'Drip Campaigns',
					path: 'drip-campaigns',
					component: DripCampaignsHome,
					redirect: 'drip-campaigns/overview',
					children: [
						{
							name: 'drip-campaigns-overview',
							path: 'overview',
							component: DripCampaignsOverview,
						},
						{
							name: 'drip-campaign-item',
							path: 'campaign/:dripCampaignId',
							component: DripCampaignItem,
						},
					],
				},
			],
		},
		{
			path: '/campaign-editor-home',
			name: 'Brand Builder',
			component: CampaignEditorHome,
			redirect: { name: 'Brand Builder Overview' },
			meta: {
				showSubNav: true,
				menuData: { iconWeight: 'fal', icon: 'ad' },
			},
			children: [
				{
					name: 'Brand Builder Overview',
					path: 'campaign-editor-overview',
					component: CampaignEditorHome,
					meta: { category: false },
				},
				{
					name: 'Brand Builder All Campaigns',
					path: 'campaign-editor-all-campaigns',
					meta: { category: 'All Campaigns' },
				},
				{
					name: 'Brand Builder Popular',
					path: 'campaign-editor-popular',
					meta: { category: 'Popular' },
				},
				{
					name: 'Brand Builder Recommended',
					path: 'campaign-editor-recommended',
					meta: { category: 'Recommended' },
				},
				{
					name: 'Brand Bulder History',
					path: 'campaign-editor-history',
					meta: { category: false },
				},
			],
		},
		{
			path: '/campaign-editor-workspace/:campaignId',
			name: 'campaign editor workspace',
			component: CampaignEditorWorkspace,
			props: { default: 0 },
			children: [
				{
					path: 'campaigns',
					component: bbCampaigns,
				},
				{
					path: 'media',
					component: bbMedia,
				},
				{
					path: 'select-content',
					component: bbSelectContent,
				},
				{
					path: 'colors',
					component: bbColors,
				},
				{
					path: 'images',
					component: bbImages,
				},
				{
					path: 'upload-images',
					component: bbUploadImages,
				},
				{
					path: 'design',
					component: bbDesign,
				},
				{
					path: 'legal',
					component: bbLegal,
				},
				{
					path: 'partners',
					component: bbPartners,
				},
				{
					path: 'preview',
					component: bbPreview,
				},
				{
					path: 'sm-preview',
				},
				{
					path: 'text',
					component: bbText,
				},
				{
					path: 'branding',
					component: bbBranding,
				},
				{
					path: 'pricing',
					component: bbPricing,
				},
				{
					path: 'export',
					component: bbExport,
				},
				{
					path: 'video-export',
					component: bbVideoExport,
				},
				{
					path: 'ppt-export',
					component: bbPptExport,
				},
			],
		},
		{
			path: '/marketing-calendar',
			name: 'Marketing Calendar',
			component: MarketingCalendarHome,
			meta: {
				showSubNav: true,
				menuData: { iconWeight: 'fal', icon: 'calendar-check' },
			},
			redirect: { name: 'Suggested' },
			children: [
				{
					name: 'Suggested',
					path: 'suggested',
					component: MarketingCalendarSuggested,
				},
				{
					name: 'Scheduled',
					path: 'scheduled',
					component: MarketingCalendarScheduled,
				},
			],
		},
		{
			path: '/marketing-resources-details/:resourceId',
			name: 'marketing resources details',
			component: MarketingResourcesDetails,
			meta: { showSubNav: true },
		},
		{
			path: '/social-analytics',
			name: 'Social Analytics',
			component: SocialAnalytics,
			meta: {
				showSubNav: false,
				menuData: {
					iconWeight: 'fal',
					icon: 'chart-bar',
					disabled: false,
				},
			},
		},
		// {
		// 	path: '/marketing-resources',
		// 	redirect: { name: 'Marketing Overview' },
		// 	name: 'Marketing Resources',
		// 	component: MarketingResourcesHome,
		// 	meta: {
		// 		showSubNav: true,
		// 		menuData: { iconWeight: 'fal', icon: 'play-circle' },
		// 	},
		// 	children: [
		// 		{
		// 			name: 'Marketing Overview',
		// 			path: 'marketing-overview',
		// 			component: MarketingViewAll,
		// 			meta: { category: false },
		// 		},
		// 		{
		// 			name: 'Quick Talks',
		// 			path: 'quick-talks',
		// 			component: MarketingViewAll,
		// 			meta: { category: 'Quick Talks' },
		// 		},
		// 		{
		// 			name: 'Tutorials',
		// 			path: 'tutorials',
		// 			component: MarketingViewAll,
		// 			meta: { category: 'Tutorials' },
		// 		},
		// 		{
		// 			name: 'Job Aids',
		// 			path: 'job-aids',
		// 			component: MarketingViewAll,
		// 			meta: { category: 'Job Aids' },
		// 		},
		// 		{
		// 			name: 'Walk-Throughs',
		// 			path: 'walk-throughs',
		// 			component: MarketingViewAll,
		// 			meta: { category: 'Walk-Throughs' },
		// 		},
		// 	],
		// },
		// {
		// 	path: '/marketing-view-all/:category',
		// 	name: 'marketing view all',
		// 	component: MarketingViewAll,
		// },
		{
			path: '/feedback',
			name: 'Feedback',
			beforeEnter() {
				store.dispatch('toggleFeedBackModal');
			},
			meta: {
				menuData: {
					iconWeight: 'fal',
					icon: 'comment-alt-exclamation',
					availableWithInvalidPreferences: true,
				},
			},
		},
		{
			path: '/preference-center',
			redirect: { name: 'User Profile' },
			name: 'Preference Center',
			component: PreferenceCenterHome,
			meta: {
				showSubNav: true,
				menuData: {
					iconWeight: 'fal',
					icon: 'toggle-on',
					availableWithInvalidPreferences: true,
				},
			},
			children: [
				{
					name: 'User Profile',
					path: 'user-profile',
					component: PreferenceCenterUser,
				},
				{
					name: 'Company Profile',
					path: 'company-profile',
					component: PreferenceCenterCompany,
				},
				{
					name: 'Disclaimers',
					path: 'disclaimers',
					component: PreferenceCenterDisclaimers,
				},
				{
					name: 'Alerts',
					path: 'Alerts',
					component: PreferenceCenterAlerts,
					beforeEnter(to, from, next) {
						if (store.state.profile.isPilotUser) {
							window.location = 'https://mkt.uwm.com/alerts';
						} else {
							next();
						}
					},
				},
				{
					name: 'Mortgage Matchup',
					path: 'mortgagematchup',
					component: PreferenceCenterFindAMortgageBroker,
					beforeEnter(to, from, next) {
						if (store.state.profile.isPilotUser) {
							window.location = 'https://mkt.uwm.com/mortgagematchup';
						} else {
							next();
						}
					},
				},
				{
					name: 'Permissions',
					path: 'permissions',
					component: PreferenceCenterPermissions,
					beforeEnter(to, from, next) {
						if (
							!store.state.profileSwitcher.mainProfileSelector
								.showPermissionsTab
						) {
							next({ path: '/preference-center', replace: true });
							return false;
						}
						if (store.state.profile.isPilotUser) {
							window.location = 'https://mkt.uwm.com/permissions';
						} else {
							next();
						}
					},
				},
				{
					name: 'Partners',
					path: 'partners',
					component: PreferenceCenterPartners,
				},
			],
		},
		{
			path: '/uwm',
			name: 'Back to UWM',
			beforeEnter() {
				window.location = 'https://www.uwm.com';
			},
			meta: {
				menuData: {
					iconWeight: 'fal',
					icon: 'arrow-circle-left',
					availableWithInvalidPreferences: true,
				},
			},
		},
		{
			path: '/log-out',
			name: 'Log Out',
			beforeEnter() {
				oidcManager.signoutRedirect();
			},
			meta: {
				menuData: {
					iconWeight: 'fal',
					icon: 'power-off',
					availableWithInvalidPreferences: true,
				},
			},
		},
		{
			path: '*',
			name: 'not-found',
			component: PageNotFound,
			meta: {
				title: 'Page Not Found',
				requiresAuth: true,
			},
		},
	],
});

async function getCurrentUserProfile() {
	if (!store.getters.isUserActive()) {
		store.dispatch('showGlobalLoadingSpinner');
		await Promise.all([
			profileApiClient.getProfile(),
			profileApiClient.getProfileSelector(),
		]);
		if (store.getters.canImpersonate) {
			await profileApiClient.getOwnersByEntity();
		}
		store.dispatch('hideGlobalLoadingSpinner');
	}
}

async function scrollToTop() {
	window.scroll(0, 0);
	// TODO: Move this reset scroll to the a route watcher inside the CampaignEditorWorkspace component.
	const bbNestedView = document.querySelector('#bb-nested-view');
	if (bbNestedView !== null) bbNestedView.scrollTop = 0;
}

function redirectToPreferenceCenter(to, next) {
	const isValidPreferences = store.getters.isValidPreferences();

	if (!isValidPreferences) {
		const paths = to.matched
			.filter((x) => x.hasOwnProperty('meta'))
			.filter((x) => x.meta.hasOwnProperty('menuData'))
			.filter((x) =>
				x.meta.menuData.hasOwnProperty('availableWithInvalidPreferences'),
			)
			.filter((x) => x.meta.menuData.availableWithInvalidPreferences);

		// If the route we're navigating to is NOT in Preference Center, then redirect there
		if (paths <= 0) {
			next({ path: '/preference-center/disclaimers', replace: true });
			return true;
		}
	}

	return false;
}

router.beforeEach(async (to, from, next) => {
	try {
		const user = await oidcManager.getUser();
		if (!user || user.expired) {
			try {
				// oidcManager redirects to sign in.
				// We save to localStorage so the attempt can persists throught the page refreshes.
				if (isBrowserStorageSupported()) {
					localStorage.setItem('isLoggedIn', 'false');
				}
				await oidcManager.signinRedirect();
			} catch (error) {
				store.dispatch('showErrorModal', {
					error,
					errorDetails: ERROR_DETAILS.AUTHENTICATION,
				});
			}
		} else {
			await getCurrentUserProfile();
			if (to.path === '/' && store.state.profile.isPilotUser) {
				next({ path: '/campaign-editor-home/campaign-editor-overview', replace: true });
			}
			// If the value is false that means we successfully logged in it is our first attempt
			if (
				isBrowserStorageSupported() &&
				window.localStorage.getItem('isLoggedIn') === 'false'
			) {
				// Prevent it from triggering again.
				localStorage.setItem('isLoggedIn', 'true');
				await profileApiClient.logUserSignIn();
			}
			scrollToTop();
			if (!redirectToPreferenceCenter(to, next)) next();
		}
	} catch (error) {
		// TODO: Notify user about error.
		console.error('Before Each Route Error:', error);
	}
});

router.afterEach((to) => {
	Vue.prototype.$gtag('config', globalConfig.googleAnalytics.key, {});
	Vue.prototype.$gtag('event', 'virtualPageview', {
		page_location: window.location.href,
		page_path: to.path,
		page_title: `Brand 360 - ${to.name}`,
	});
});

export default router;
